module.exports = __webpack_public_path__ + "img/real-estates.50d3f713.svg";